export default "__VITE_ASSET__BrZczykj__"